import React from 'react'

const Loading: React.FC = () => {
  return (
    <div id="loading-indicator">
      <div className="spinner"></div>
    </div>
  )
}

export default Loading 